import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";

type InsuranceCoverageMonitorSettings =
  insuranceMonitorApiSpec.InsuranceCoverageMonitorSettings;
type InsuranceCoverageSource = insuranceMonitorApiSpec.InsuranceCoverageSource;

export const selectorIsAcceptedSourceTypeIncluded = (
  acceptedSourceType: InsuranceCoverageSource,
  insuranceCoverageMonitorSettings?: InsuranceCoverageMonitorSettings
) => {
  return insuranceCoverageMonitorSettings?.coverages?.some(coverage =>
    coverage.acceptedSourceTypes?.includes(acceptedSourceType)
  );
};
